let parallaxBanner = (function(){
	let banner 		= $('#banner-principal');
	let items 		= $('#banner-principal .carousel-item');
	let faixaTopo 	= $('.faixa-topo');
	let jaPrllx		= false;

	let prllx = function(){
		let wp = $(window).scrollTop();
		let fxh = faixaTopo.outerHeight();

		if(wp > fxh){
			let t = (wp - fxh) / 2;

			items.css('transform', `translateY(${t}px)`);
		}else{
			items.css('transform', `translateY(0)`);
		}
	}

	prllx();

	$(window).scroll(function(){
		if(jaPrllx) return;

		setTimeout(function(){
			jaPrllx = false;
		}, 100);

		prllx();
	});
})();